import { useState } from 'react';
import { TextField } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { makeStyles } from '@mui/styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            color: 'black'
        }
    },
    chip: {
        display: 'none'
    }
}));

export function FilterByLast4({ cards, setSelectedLast4, selectedLast4, setPagination }) {
    const classes = useStyles();
    const [shrink, setShrink] = useState(false);

    const handleSearchChange = async (event, newValue) => {
        setSelectedLast4(newValue);
        setPagination({
            page: 0,
            rowsPerPage: 10
        });
    };

    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: option => `${option.solidData.last4}`
    });

    const handleFocus = async () => {
        setShrink(true);
    };
    const handleBlur = async () => {
        setShrink(false);
    };

    return (
        <Autocomplete
            renderInput={params =>
                selectedLast4.length === 0 ? (
                    <TextField {...params} InputLabelProps={{ shrink: shrink }} label="All Cards" />
                ) : selectedLast4.length === 1 ? (
                    <TextField {...params} InputLabelProps={{ shrink: shrink }} label="1 Card" />
                ) : (
                    <TextField {...params} InputLabelProps={{ shrink: shrink }} label={`${selectedLast4.length} Cards`} />
                )
            }
            classes={classes}
            options={cards}
            getOptionLabel={option => `${option.solidData.department}`}
            clearOnEscape={true}
            onFocus={handleFocus}
            onBlur={handleBlur}
            filterOptions={filterOptions}
            renderOption={(props, option, { selected }) => (
                <li {...props} key={option.id}>
                    <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                    <li style={{ width: 380, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        <span style={{ color: '#122d55', fontSize: 15, fontWeight: 500 }}>****{option.solidData.last4}</span>
                    </li>
                </li>
            )}
            onChange={handleSearchChange}
            multiple
            disableCloseOnSelect
            size="small"
            ChipProps={{ className: classes.chip, disabled: 'true', size: 'small', deleteIcon: 'none' }}
            id="search-last4-autocomplete"
            sx={{
                width: '100%'
            }}
            className="transactions-search__item"
        />
    );
}
